export default {

    // EMPLOYEE

    ADD_EMPLOYEE: {
        url: "/api/v1/employee",
        method: "post",
    },

    EXPORT_EMPLOYEES: {
        url: "/api/v1/employee/export",
        method: "get"
    },

    GET_EMPLOYEES: {
        url: "/api/v1/employee",
        method: "get"
    },

    GET_EMPLOYEE_BY_ID: {
        url: "/api/v1/employee/{employee_id}",
        method: "get"
    },

    UPDATE_EMPLOYEE: {
        url: "/api/v1/employee/{employee_id}",
        method: "put"
    },
    DELETE_EMPLOYEE: {
        url: "/api/v1/employee/{employee_id}",
        method: "delete"
    },
}